import React from 'react'

let Vite = () =>
    <article>
        <h1>Vite</h1>
        <p>La vite <i>(Vitis vinifera)</i> è una specie che presenta una vasta adattabilità alle varie condizioni climatiche.</p>
        <p>La sua coltivazione è strettamente legata a parametri come la radiazione solare (parametro che influenza il grado zuccherino, il colore e l’epoca di maturazione), la temperatura (fattore determinante in tutte le fasi fenologiche della pianta) e la disponibilità di acqua (fabbisogno variabile a seconda delle diverse fasi vegetative).</p>
        <p>La mancanza di un controllo adeguato di questi parametri ambientali e delle condizioni favorevoli lo sviluppo di patogeni, può determinare effetti negativi sulla produzione dal punto di vista sia quantitativo sia qualitativo.</p>
        <p><b>Agrismart</b> controlla lo stato del vigneto in base alla geo-localizzazione e invia alert automatici relativi alla necessità di interventi irrigui e a possibili rischi di malattie, fornendo un supporto all'agricoltore nella gestione delle attività aziendali.</p>
    </article>

export let Peronospora = () =>
    <article>
        <h1>Peronospora</h1>
        <p>La peronospora è indubbiamente la più importante malattia che colpisce la vite, essendo in grado di causare ingenti danni vegetativi e produttivi. Infatti attaccando i raspi nel corso della fioritura, distrugge interamente la produzione.</p>
        <p>In primavera le infezioni hanno inizio quando si raggiungono, contemporaneamente, determinate condizioni microclimatiche, conosciute come la regola dei “tre dieci”, che possono essere sintetizzate come segue:</p>
        <ul>
            <li>temperatura media al di sopra di 10 °C;</li>
            <li>piovosità, negli ultimi giorni, di almeno 10 mm;</li>
            <li>lunghezza media dei giovani germogli di circa 10 cm. </li>
        </ul>
       
        <h2>Sintomi:</h2>
        <ul>
            <li>sono attaccati tutti gli organi erbacei. Nelle giovani e tenere foglie, in primavera, il primo sintomo è la macchia d’olio;</li>
            <li>alla macchia d’olio segue la fuoriuscita dell’efflorescenza biancastra della pagina inferiore e l’imbrunimento e necrosi dei tessuti colpiti;</li>
            <li>l’umidità relativa elevata stimola la produzione della muffa;</li>
            <li>in condizioni di temperatura e umidità relativa elevate, muffa e necrosi possono verificarsi senza la preliminare manifestazione della “macchia d’olio”;</li>
            <li>i grappoli possono essere attaccati nelle prime fasi dello sviluppo con disseccamento parziale o totale e successivo distacco delle parti infette.</li>
        </ul>
        <figure>
            <img src={require('img/pictures/vite-peronospora-sintomi.jpg')} alt="" />
            <figcaption>Principali sintomi della peronospora.</figcaption>
        </figure>
        
        <h2>Difesa:</h2>
        <ul>
            <li>adottare forme di allevamento e tecniche che agevolano l’areazione;</li>
            <li>limitare le concimazioni con azoto e l’irrigazione;</li>
            <li>eliminare i ricacci basali in quanto sono focolai di infezioni primarie;</li>
            <li>lavorazione del terreno.</li>
        </ul>
    </article>

export let Oidio = () =>
    <article>
        <h1>Oidio</h1>
        <p>L’Oidio è una malattia della vite generata anch’essa da un fungo e si manifesta sugli acini con la caratteristica muffa bianca, sotto la quale sono presenti necrosi reticolate bruno nerastro <i>(Ascomycota)</i> che si sviluppa soprattutto in presenza di condizioni climatiche umide, mediamente calde e in caso di scarsa aerazione.</p>
        <p>L’oidio di presenta sulla pianta in due forme che possono coesistere:</p>
        <ul>
            <li>forma ascofora <i>(Uncinula necator)</i>, con spore racchiuse in organi detti cleistoteci, i quali si aprono con piogge di almeno 2,5 mm e temperatura superiore ai 10° C.</li>
            <li>forma conidica <i>(Oidium tuckeri)</i> con sviluppo anche a temperature basse (a partire dai 5° fino ai 30/35° C, ottimale a 27° C) e in presenza di scarsa umidità relativa (inferiore al 50%).</li>
        </ul>
        <p>In entrambe le forme, lo oidio può svernare sulla vite e manifestarsi dall’inizio della primavera fino all’estate. Il periodo di maggiore suscettibilità per i frutti infatti è dalla fioritura alla invaiatura.</p>
        <p>Recenti studi hanno dimostrato che quando gli acini raggiungono una certa dimensione, diventano più resistenti al patogeno. Elementi di monitoraggio per la forma <b>Ascofora</b>:</p>
        <ul>
            <li>temperatura media &gt; 10 °C;</li>
            <li>piovosità (ultimi giorni) di almeno 2.5 mm di acqua;</li>
        </ul>
        <p>Elementi di monitoraggio per la forma <b>Conidica</b>:</p>
        <ul>
            <li>temperatura media tra i 10 °C e 35 °C;</li>
            <li>umidità relativa (inferiore al 50%).</li>
        </ul>
        <p>Il micelio sopravvive nelle gemme che, a primavera, si dischiudono in germogli completamente ricoperti di muffa bianca (i cosiddetti tralci a bandiera). Il fungo sporula e, attraverso i conidi, infetta le parti verdi della pianta, dalle foglie ai grappoli. I cleistoteci, in cui sono racchiuse le ascospore del fungo, si formano su foglie, bacche e germogli nella tarda estate. Svernano sulla corteccia dei tralci dove sono dilavati e restano chiusi fino a primavera. Con la loro apertura, si infettano i tessuti verdi della vite su cui il fungo continua a sporulare.</p>
        <p>In entrambi i casi, i conidi prodotti sono dispersi dal vento, causando infezioni secondarie.</p>
        
        <h2>Sintomi:</h2>
        <ul>
            <li>attacca le foglie, le infiorescenze, i tralci ancora verdi e i grappoli, ricoprendoli di un pulviscolo bianco-grigiastro a contorno indefinito;</li>
            <li>i tralci malati lignificano incompletamente e sono facilmente uccisi dai freddi invernali;</li>
            <li>le foglie si deformano e funzionano in modo irregolare e gli acini non maturano e si spaccano per la pressione che la polpa esercita sull’epidermide alterata.</li>
        </ul>
        <figure>
            <img src={require('img/pictures/vite-oidio-sintomi.jpg')} alt="" />
            <figcaption>Principali sintomi dell'oidio.</figcaption>
        </figure>

        <h2>Difesa:</h2>
        <ul>
            <li>deve essere combattuto a livello preventivo, mai a livello curativo;</li>
            <li>a differenza dell’infezione da peronospora, non si può agire solo quando compaiono i sintomi ma bisogna intervenire fra ripresa vegetativa e inizio fioritura, se necessario (es. copertura con reti antigrandine).</li>
        </ul>
    </article>

export let Botrite = () =>
    <article>
        <h1>Botrite</h1>
        <p>La botrite, anche detta muffa grigia della vite, è tra le malattie fungine più gravi che minacciano la viticoltura italiana.</p>
        <p>Il fungo si sviluppa in un ambiente caldo-umido e attacca i frutti della vite, inoculandosi attraverso le ferite della bacca.</p>
        <p>La botrite inizia dal momento in cui si verifica la regola dei "due quindici”:</p>
        <ul>
            <li>temperatura media &gt; 15 °C;</li>
            <li>15 ore di bagnatura.</li>
        </ul>
        <p>Quest’ultimo punto varia a seconda dello stato di salute dell’acino e allo stadio di maturazione, esattamente:</p>
        <ul>
            <li>acini integri, in stadio invaiatura, richiedono: 16 ore;</li>
            <li>acini lesionati, in stadio allegagione: 8 ore;</li>
            <li>acini lesionati, in stadio viraggio del colore: 4 ore.</li>
        </ul>
        
        <h2>Sintomi:</h2>
        <ul>
            <li>colpisce soprattutto acini con ferite (causate da gelate, oidio, insetti, grandine) e può attaccare i fiori precocemente (a causa di nebbia o umidità elevate).</li>
            <li>gli attacchi più gravi si verificano sui grappoli con la comparsa di una efflorescenza grigiastra.</li>
        </ul>
        <figure>
            <img src={require('img/pictures/vite-botrite-sintomi.jpg')} alt="" />
            <figcaption>Principali sintomi della botrite.</figcaption>
        </figure>
        
        <h2>Difesa:</h2>
        <ul>
            <li>Evitare eccessi idrici, eccessive concimazioni, potature non adeguate</li>
        </ul>
    </article>

export default Vite